import { Flex, Box } from 'rebass'
import styled from '@emotion/styled'
import facebook from '../../assets/icons/facebook.svg'
import twitter from '../../assets/icons/twitter.svg'
import instagram from '../../assets/icons/instagram.svg'
import youtube from '../../assets/icons/youtube.svg'

const IconBox = styled(Box)`
  width: 0.9rem;
`
const SocialGroup = () => {
  return (
    <Flex alignItems="center" height={'1rem'}>
      <a
        href={'https://www.facebook.com/BoroumandCenter/'}
        target="_blank"
        rel="noreferrer"
      >
        <IconBox mr={2}>
          <img src={facebook} alt={'facebook'} />
        </IconBox>
      </a>
      <a
        href={'https://twitter.com/IranRights_org'}
        target="_blank"
        rel="noreferrer"
      >
        <IconBox mr={2}>
          <img src={twitter} alt={'twitter'} />
        </IconBox>
      </a>
      <a
        href={'https://www.youtube.com/user/ABFIran'}
        target="_blank"
        rel="noreferrer"
      >
        <IconBox mr={2} mb={'2px'}>
          <img src={youtube} alt={'youtube'} />
        </IconBox>
      </a>
      <a
        href={'https://www.instagram.com/iranrights/'}
        target="_blank"
        rel="noreferrer"
      >
        <IconBox mr={2} mt={'2px'}>
          <img src={instagram} alt={'instagram'} />
        </IconBox>
      </a>
    </Flex>
  )
}

export default SocialGroup
